import {parseAxiosPromise} from '@/axiosInstance'
import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {captureException} from '@sentry/react'
import {httpGetAslByCoordinates} from './address.http'
import {AslDistrict, Coordinates, ResponseType} from '@/types'

export const useGetAslByCoordinates = ({
    coordinates,
    responseType,
    options
}: {
    coordinates?: Coordinates
    responseType: ResponseType
    options?: Omit<UseQueryOptions<AslDistrict>, 'queryFn' | 'queryKey'>
}) => {
    return useQuery({
        queryKey: [QUERY_KEYS.ASL_BY_COORDINATES, coordinates],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetAslByCoordinates({
                    latitude: coordinates?.latitude,
                    longitude: coordinates?.longitude,
                    responseType
                }),
                responseShape: AslDistrict,
                onZodError: captureException
            }),
        ...options
    })
}
